import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { PageHero } from '../components/PageHero';
import { Share2 } from 'lucide-react';

const DatenschutzSocialMediaPage = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />
      <main className="flex-1">
        
        {/* Einheitlicher Hero mit PageHero Komponente */}
        <PageHero
          title="Datenschutz Social Media"
          subtitle="Informationen zur Datenverarbeitung in sozialen Netzwerken"
          badges={[
            { icon: Share2, text: 'Social Media', bgColor: 'bg-indigo-600 text-white' },
            { text: 'Facebook & Instagram', variant: 'white' }
          ]}
          backgroundImage="https://customer-assets.emergentagent.com/job_erste-hilfe-portal/artifacts/pp37a6ir_D9699C83-842A-4B21-9A1E-BF70A2BC27F0.png"
          backgroundPosition="center 40%"
          variant="simple"
        />

        {/* INHALT - Same container width as navbar */}
        <section className="py-12 sm:py-16">
          <div className="max-w-[1664px] mx-auto px-4 sm:px-6 lg:px-8">
            <div className="prose prose-lg max-w-none text-slate-600 space-y-6">
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Anbieter / Diensteanbieter</h2>
              <p>
                Erste Hilfe Germany GbR<br />
                Poststraße 6<br />
                46236 Bottrop<br />
                Deutschland
              </p>
              <p>
                <strong>Vertretungsberechtigte Gesellschafter:</strong><br />
                Herr Yasar Kartal<br />
                Herr Jan Hassel
              </p>
              <p>
                Die Gesellschaft wird durch die Gesellschafter gemeinschaftlich vertreten.<br />
                Beide Gesellschafter haften im Rahmen der gesetzlichen Vorschriften.
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Verantwortlich im Sinne des § 18 MStV</h2>
              <p>
                Verantwortlich für den Inhalt:<br /><br />
                Herr Yasar Kartal<br />
                Herr Jan Hassel<br />
                Poststraße 6<br />
                46236 Bottrop
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Social Media Präsenzen</h2>
              <p>
                Wir unterhalten Onlinepräsenzen innerhalb sozialer Netzwerke, um mit den dort aktiven 
                Kunden, Interessenten und Nutzern zu kommunizieren und sie dort über unsere Leistungen 
                informieren zu können.
              </p>
              <p>
                Wir weisen darauf hin, dass dabei Daten der Nutzer außerhalb des Raumes der 
                Europäischen Union verarbeitet werden können. Hierdurch können sich für die Nutzer 
                Risiken ergeben, weil so z.B. die Durchsetzung der Rechte der Nutzer erschwert 
                werden könnte.
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Datenverarbeitung durch soziale Netzwerke</h2>
              <p>
                Ferner werden die Daten der Nutzer innerhalb sozialer Netzwerke im Regelfall für 
                Marktforschungs- und Werbezwecke verarbeitet. So können z.B. anhand des 
                Nutzungsverhaltens und sich daraus ergebender Interessen der Nutzer Nutzungsprofile 
                erstellt werden.
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Facebook</h2>
              <p>
                Wir sind gemeinsam mit Facebook Irland Ltd. für die Erhebung oder den Erhalt im 
                Rahmen einer Übermittlung von „Event-Daten" verantwortlich. Zu diesen Daten gehören 
                Daten, die Facebook von Nutzern sammelt, die mit unserer Facebook-Seite interagieren.
              </p>
              <p>
                Weitere Informationen finden Sie in der Datenschutzerklärung von Facebook: 
                <a href="https://www.facebook.com/privacy/explanation" target="_blank" rel="noopener noreferrer" className="text-red-600 hover:underline">
                  https://www.facebook.com/privacy/explanation
                </a>
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Instagram</h2>
              <p>
                Instagram ist ein Dienst der Meta Platforms Ireland Limited. Informationen darüber, 
                wie Instagram Ihre Daten verarbeitet, finden Sie in der Datenschutzerklärung von Instagram: 
                <a href="https://help.instagram.com/519522125107875" target="_blank" rel="noopener noreferrer" className="text-red-600 hover:underline">
                  https://help.instagram.com/519522125107875
                </a>
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Ihre Rechte</h2>
              <p>
                Bezüglich der Verarbeitung Ihrer Daten durch die Social Media Plattformen haben Sie 
                die Möglichkeit, Ihre Rechte (Auskunft, Berichtigung, Löschung, Einschränkung der 
                Verarbeitung, Datenübertragbarkeit und Beschwerde) sowohl gegenüber uns als auch 
                gegenüber dem jeweiligen Betreiber des Social Media Portals geltend zu machen.
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">Kontakt</h2>
              <p>
                Bei Fragen zum Datenschutz im Zusammenhang mit unseren Social Media Präsenzen können Sie uns kontaktieren:<br />
                E-Mail: info@erstehilfebottrop.de<br />
                Telefon: 02041 9878 666
              </p>
            </div>
          </div>
        </section>

      </main>
      <Footer />
    </div>
  );
};

export default DatenschutzSocialMediaPage;
